/* global d3 */
import "core-js/features/array/find.js";
import { dataTypeFormatter } from "../../../../../Common/js/common/formatters.js";
import * as R from "ramda";

// filterMapData: Filter map data by year
export function filterMapData(data, year, showMostRecent) {
  let filteredLocations = [];

  if (showMostRecent) {
    // Return the data for either the selected year,
    // or the most recent year that's less than the selected year
    return R.pipe(
      R.sortWith([
        R.ascend(R.prop("name")),
        R.ascend(R.prop("code")),
        R.descend(R.prop("year")),
      ]),
      R.filter((d) => {
        if (d.year === year) {
          // It's the exact year, always accept
          filteredLocations = [...filteredLocations, d.code];
          return true;
        } else if (d.year < year && !filteredLocations.includes(d.code)) {
          // It's less than the exact year, but we haven't accepted yet
          // so it's the next most recent year
          filteredLocations = [...filteredLocations, d.code];
          return true;
        } else {
          return false;
        }
      }),
    )(data);
  } else {
    // Only return the data for the selected year
    return R.filter((d) => d.year === year, data);
  }
}

export default function make_world_map({
  svgEl,
  mapData,
  mapIndicatorData,
  mapLocationData,
  mapDataType,
  year,
  showMostRecent,
}) {
  var svg = d3.select(svgEl);
  var width = +svg.attr("width");
  var height = +svg.attr("height");

  const formatter = dataTypeFormatter(mapDataType);

  // tooltip
  var tooltip = d3.select("body").append("div");
  tooltip
    .style("display", "none")
    .style("position", "absolute")
    .style("border", "1px solid #FFFFFF")
    // .style("box-shadow", "2px 2px 3px 0px #D8D8D8")
    .style("padding-top", "17px")
    .style("padding-left", "17px")
    .style("padding-bottom", "10px")
    .style("padding-right", "22px")
    .style("background", "#0098A7")
    .style("font-size", 12)
    .style("width", "auto")
    .style("border-radius", "2px")
    //.style("border-color", "#FFFFFF")
    .style("color", "#4B4B4B");

  var firstDraw = true;

  // Map and projection
  var projection = d3
    .geoNaturalEarth1()
    //.scale(width / 2 / Math.PI)
    .scale(width / 1.7 / Math.PI)
    .translate([width * 0.45, height * 0.6]);

  var path = d3.geoPath().projection(projection);

  // Data and color scale
  var data = d3.map();
  var locationNames = d3.map();
  var selectedYears = d3.map();

  // Load external data and boot
  d3.queue()
    // .defer(
    //   d3.json,
    //   "http://enjalot.github.io/wwsd/data/world/world-110m.geojson",
    // )
    // .defer(d3.json, "{% static 'demos_app/world-map-2/world-110m.geojson' %}")
    // .defer(d3.json, "/static/stunting/peru/js/world-110m.geojson.json")
    .defer(
      d3.json,
      "/Areas/EGH/assets/files/ne_50m_admin_0_countries.geojson.json",
    )
    // .defer(d3.csv, "{% static 'demos_app/world-map-2/mooc-countries.csv' %}", function(d) { return data.set(d.code, +d.total); })
    .await(ready);

  function ready(error, topo) {
    if (error) throw error;

    // Draw the map
    function drawTopicWorldMap(callData, year) {
      const filteredData = filterMapData(callData, year, showMostRecent);

      filteredData.forEach(function (element) {
        data.set(element.code, +element.total);
        selectedYears.set(element.code, showMostRecent ? element.year : year);
      });

      mapData.forEach((location) => {
        locationNames.set(location.code, location.name);
      });

      const colorScheme = ["#c8e9f0", "#0099a6", "#149aa8"];

      const domain = R.compose(d3.extent, R.map(R.prop("total")))(filteredData);

      const scalePivot = (domain[1] - domain[0]) / 2 + domain[0];

      var colorScale = d3
        .scaleLinear()
        .domain([domain[0], scalePivot, domain[1]])
        .range(colorScheme);

      if (firstDraw) {
        var legend = svg
          .append("defs")
          .append("svg:linearGradient")
          .attr("id", "gradient")
          .attr("x1", "0%")
          .attr("y1", "100%")
          .attr("x2", "100%")
          .attr("y2", "100%")
          .attr("spreadMethod", "pad");

        legend
          .append("stop")
          .attr("offset", "0%")
          .attr("stop-color", colorScheme[0])
          .attr("stop-opacity", 1);

        legend
          .append("stop")
          .attr("offset", "50%")
          .attr("stop-color", colorScheme[1])
          .attr("stop-opacity", 1);

        legend
          .append("stop")
          .attr("offset", "100%")
          .attr("stop-color", colorScheme[2])
          .attr("stop-opacity", 1);

        svg
          .append("rect")
          .attr("width", 150)
          .attr("height", 10)
          .attr("x", 12)
          .attr("y", height - 60)
          .style("fill", "url(#gradient)")
          .attr("transform", "translate(0,10)");
        svg
          .append("text")
          .attr("x", 5)
          .attr("y", height - 25)
          .text(formatter(domain[0]))
          .attr("font-size", "12px")
          .attr("text-anchor", "start");
        svg
          .append("text")
          .attr("x", 162)
          .attr("y", height - 25)
          .text(formatter(domain[1]))
          .attr("font-size", "12px")
          .attr("text-anchor", "middle");
        svg
          .append("g")
          .attr("class", "countries")
          .selectAll("path")
          .data(topo.features)
          .enter()
          .append("path")
          .attr("class", "country")
          .attr("fill", function (d) {
            d.total = data.get(d.properties.iso_a3) || 0;
            return d.total == 0 ? "#E7E6E5" : colorScale(d.total);
          })
          .attr("d", path)
          .on("mousemove", function (d) {
            d3.selectAll("#tooltipLine > *").remove();

            tooltip
              .style("top", d3.event.pageY - 30 + "px")
              .style("left", d3.event.pageX + 12 + "px")
              .style("display", "inherit")
              .html(function () {
                var number_position = -5;

                var html = "";

                var line_svg =
                  "<svg id='tooltipLine' width='150' height='45'></svg>";

                var tooltip_text =
                  "<span id='indicator_number_a' style='font-weight: bold; color: #FFFFFF; position: relative; top: " +
                  number_position +
                  "px; font-style: italic; font-size: 16px;'>" +
                  formatter(d.total) +
                  "</span>";

                var small_text =
                  "<span style='color: #FFFFFF; display: block; font-size: 12px; line-height: 14px; font-style: italic;'></span>";

                if (d.total == 0) {
                  tooltip_text =
                    "<span id='indicator_number_a' style='font-weight: bold; color: #FFFFFF; position: relative; top: -5px; font-style: italic; font-size: 16px;'></span>";
                  small_text =
                    "<span style='color: #FFFFFF; display: block; font-size: 12px; line-height: 14px; font-style: italic; margin-top: -30px; margin-bottom: 10px;'>Data unavailable.</span>";
                }

                const locationLookup = R.indexBy(
                  R.prop("fips"),
                  mapLocationData,
                );

                // Country name logic:
                // 1. Check for a country name in the client-provided data.
                // 2. If that doesn't exist, check for the geoJSON data name.
                // 3. If that doesn't exist, use "Country name unavailable."
                var country_name =
                  typeof locationLookup[d.properties.iso_a3] !== "undefined"
                    ? locationLookup[d.properties.iso_a3].name
                    : typeof d.properties.name !== "undefined"
                    ? d.properties.name
                    : "Country name unavailable";
                var tooltip_year =
                  selectedYears.get(d.properties.iso_a3) || year;

                html =
                  "<div style='position: absolute; left: 9px; top: 30%; width: 0; height: 0; border: 8px solid transparent; border-right-color: #FFFFFF; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>";
                html +=
                  "<div style='position: absolute; left: 11px; top: 30%; width: 0; height: 0; border: 8px solid transparent; border-right-color: #0098A7; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>";
                html +=
                  "<div class='row' style='margin-right: -5px; margin-left: -5px; margin-top: -5px; margin-bottom: 5px;'>";
                html +=
                  "<span style='font-weight: bold; padding-left: 5px; color: #FFFFFF; font-size: 20px;'>" +
                  country_name +
                  ", " +
                  tooltip_year +
                  "</span></br>";
                html += "</div>";
                // html += "<hr style='border: 0; height: 1px; border-top: .5px solid #e2e2e2; opacity: 0.5; margin: 5px 0 5px 0;'>"
                // html += "<div style='background: #FFFFFF; height: 1px; margin-top: 11px; margin-bottom: 12px; opacity: 0.1;'></div>"
                html +=
                  "<span style='font-size: 12px; color: #FFFFFF; line-height: 18px; font-weight: 500;'>" +
                  mapIndicatorData.name +
                  "</span>";
                html += "<div style='margin-top: 5px;' width='200px'>";
                html += line_svg;
                // html += "<span style='font-weight: bold; color: #0098A7;'>" + d3.format(",.1%")(d.total) + "*" + "</span>"
                html += tooltip_text;
                html += "</div>";
                //html += "<div style='background: #FFFFFF; height: 1px; margin-top: 0px; margin-bottom: 11px;'></div>"
                html += small_text;

                return html;
              });

            var tooltipData = callData.filter(function (ele) {
              return ele.code == d.properties.iso_a3;
            });

            var tooltipSvg = d3.select("#tooltipLine");

            var tooltipMargin = { top: 5, right: 20, bottom: 10, left: 10 };

            var tooltipWidth =
              tooltipSvg.attr("width") -
              tooltipMargin.left -
              tooltipMargin.right;

            var tooltipHeight =
              tooltipSvg.attr("height") -
              tooltipMargin.top -
              tooltipMargin.bottom;

            var tooltipG = tooltipSvg
              .append("g")
              .attr(
                "transform",
                "translate(" +
                  tooltipMargin.left +
                  "," +
                  tooltipMargin.top +
                  ")",
              );

            var tooltipX = d3
              .scaleLinear()
              .domain([1995, 2016])
              .range([0, tooltipWidth]);

            var tooltipY = d3
              .scaleLinear()
              .domain(
                d3.extent(tooltipData, function (elem) {
                  return elem.total;
                }),
              )
              .range([tooltipHeight, 0]);

            var tooltipLine = d3
              .line()
              .x(function (d) {
                return tooltipX(d.year);
              })
              .y(function (d) {
                return tooltipY(d.total);
              })
              .curve(d3.curveLinear);

            tooltipG
              .append("path")
              .datum(tooltipData)
              .attr("class", "line")
              //.style("stroke", "#88CBD3")
              .style("stroke", "#FFFFFF")
              .style("fill", "none")
              .style("stroke-width", 1.5)
              .attr("d", tooltipLine);

            tooltipG
              .append("circle")
              .data(
                tooltipData.filter(function (ele) {
                  return ele.year == year;
                }),
              )
              .attr("cx", function (d) {
                return tooltipX(d.year);
              })
              .attr("cy", function (d) {
                return tooltipY(d.total);
              })
              .attr("r", 3)
              //.attr("fill", "#88CBD3")
              .attr("fill", "#FFFFFF");

            // hide the spark line if there is no data
            tooltipSvg.style(
              "visibility",
              d.total === 0 ? "hidden" : "visible",
            );

            d3.select(this).style("opacity", 0.5);
            var tooltip_offset = -30 + tooltipY(d.total) - 5;

            d3.select("span#indicator_number_a").style(
              "top",
              tooltip_offset + "px",
            );
          })
          .on("mouseout", function () {
            tooltip.style("display", "none");
            d3.select(this).style("opacity", 1);
          });

        firstDraw = false;
      } else {
        svg
          .selectAll(".country")
          .data(topo.features)
          .transition()
          .duration(800)
          .attr("fill", function (d) {
            d.total = data.get(d.properties.iso_a3) || 0;
            return d.total == 0 ? "#E7E6E5" : colorScale(d.total);
          });
      }

      svg
        .selectAll(".countries")
        .style("fill", "none")
        .style("stroke", "#FFFFFF")
        .style("stroke-width", ".5px")
        .style("stroke-linejoin", "round");
    }

    drawTopicWorldMap(mapData, year);

    // d3.select("#changeData").on("click", function(){
    //     if (!buttonPush) {
    //         drawTopicWorldMap(mapData, 2010);
    //         buttonPush = true;
    //     } else {
    //         drawTopicWorldMap(mapData, 2015);
    //         buttonPush = false;
    //     }
    // })
  }
}
